import type { BackendRouteDefinition } from '../types';
import { callFinixProxyRoute } from './callFinixProxy';
import { getAdminFirmsRoute } from './getAdminFirms';
import { getAdminMattersRoute } from './getAdminMatters';
import { getMostVisitedPagesRoute } from './getMostVisitedPages';
import { getPageVisitorsRoute } from './getPageVisitors';
import { listIdentitiesRoute } from './listIdentities';
import { listMerchantsRoute } from './listMerchants';
import { listPaymentInstrumentsRoute } from './listPaymentInstruments';
import { listSubcollectionsRoute } from './listSubcollections';
import { listTransfersRoute } from './listTransfers';
import { otherRoutes } from './otherRoutes';

export const routeTable = {
  ...otherRoutes,
  getAdminFirms: getAdminFirmsRoute,
  // PRA-794 (Phase 5 Sub-phase 6, S6-WB1): admin matters read now routes to
  // `api-core-node`. The cloudFunctions callable stays in place until
  // S9-WB2.
  getAdminMatters: getAdminMattersRoute,
  listSubcollections: listSubcollectionsRoute,
  getMostVisitedPages: getMostVisitedPagesRoute,
  getPageVisitors: getPageVisitorsRoute,
  // PRA-776 (Phase 5 Sub-phase 1): Finix admin reads + proxy now route to
  // `api-core-node`. Each route lives in its own file so the eventual
  // retirement-sweep block (Sub-phase 9) can delete entries one at a time.
  listIdentities: listIdentitiesRoute,
  listMerchants: listMerchantsRoute,
  listPaymentInstruments: listPaymentInstrumentsRoute,
  listTransfers: listTransfersRoute,
  callFinixProxy: callFinixProxyRoute,
} as const satisfies Record<string, BackendRouteDefinition>;
